import { DiagnosticContextProvider } from 'features/diagnostics/context/provider';
import { ServiceOffersProvider } from 'features/offer/state/service-offers-context';
import { PaymentProvider } from 'features/payment';
import { StoreProvider } from 'features/store';
import { KeyboardProvider } from 'react-native-keyboard-controller';

import { ConfettiFriesAnimationProvider } from 'components/lottie-animations/confetti-fries';
import { ToasterProvider } from 'components/toaster/toaster-provider';
import { AttPermissionProvider } from 'state/app-tracking-transparency-permissions';
import { AuthProvider } from 'state/auth';
import { BrazeProvider } from 'state/braze';
import { ErrorsProvider } from 'state/errors';
import { ExperimentsProvider } from 'state/experiments';
import { FavoritesProvider } from 'state/favorites';
import { GeolocationProvider } from 'state/geolocation';
import { GlobalStateProvider } from 'state/global-state/provider';
import { GraphQLProvider } from 'state/graphql';
import { HelmetProvider } from 'state/helmet';
import { IntlProvider } from 'state/intl';
import { LDProvider } from 'state/launchdarkly/platform-client';
import { LocationProvider } from 'state/location';
import { LoyaltyProvider } from 'state/loyalty';
import { MenuProvider } from 'state/menu';
import { NetworkProvider } from 'state/network';
import { OrderProvider } from 'state/order';
// import { PaymentProvider as PaymentProviderV2 } from 'state/payments';
import { ScrollProvider } from 'state/scroll';
import { ServiceModeProvider } from 'state/service-mode';
import { DerivedServiceModeProvider } from 'state/service-mode/derived';
import { SmartAlertsProvider } from 'state/smart-alert';
import { PageManagerProvider } from 'state/static-page-manager';
import { UIProvider } from 'state/ui';
import { UnifiedMenuProvider } from 'state/unified-menu';

import { UclProvider } from './ucl';

/** IMPORTANT: providers here should:
 * - rely on React Compiler to keep provider values stable
 * - NOT conditionally wrap children or return children or this will cause re-renders/remounts of the app/router causing subtle bugs
 */
const useProviders = () => {
  return [
    KeyboardProvider,
    UclProvider,
    GlobalStateProvider,
    LDProvider,
    IntlProvider,
    LocationProvider,
    GraphQLProvider,
    ExperimentsProvider,
    DiagnosticContextProvider,
    BrazeProvider,
    ErrorsProvider,
    NetworkProvider,
    AuthProvider,
    UIProvider,
    ToasterProvider,
    ServiceModeProvider,
    StoreProvider,
    DerivedServiceModeProvider,
    LoyaltyProvider,
    ServiceOffersProvider,
    UnifiedMenuProvider,
    MenuProvider,
    PaymentProvider,
    PageManagerProvider,
    OrderProvider,
    FavoritesProvider,
    GeolocationProvider,
    SmartAlertsProvider,
    HelmetProvider,
    ScrollProvider,
    ConfettiFriesAnimationProvider,
    AttPermissionProvider,
  ];
};

export default useProviders;
